module.exports = __webpack_public_path__ + "img/language_icon.8118e834.svg";